/**
 * Помнит, на какой странице/с каким поиском был открыт список раздела, чтобы
 * ссылки «← К списку» и «Отмена» в карточке возвращали туда же, а не в начало.
 * Хранится в sessionStorage: живёт в пределах вкладки.
 */

const KEY = 'adm:list:';

export const rememberListUrl = (pathname, search) => {
    try {
        sessionStorage.setItem(KEY + pathname, search || '');
    } catch (e) {
        // sessionStorage может быть недоступен (приватный режим) — тогда просто без памяти.
    }
};

export const listUrl = (pathname) => {
    try {
        return pathname + (sessionStorage.getItem(KEY + pathname) || '');
    } catch (e) {
        return pathname;
    }
};
